import { render, staticRenderFns } from "./DeclineReasonModal.vue?vue&type=template&id=2c9a95f5"
import script from "./DeclineReasonModal.vue?vue&type=script&lang=js"
export * from "./DeclineReasonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports